<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="厂家名称">
              <a-input placeholder="请输入厂家名称" v-model="queryParam.manuName"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('制造商')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1"> <a-icon type="delete" />删除 </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-wrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else
            >下载</a-button
          >
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <common-manufacturer-modal @ok="modalFormOk" ref="modalForm"></common-manufacturer-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import CommonManufacturerModal from './modules/CommonManufacturerModal'
import { mapActions } from 'vuex'
export default {
  name: 'CommonManufacturerList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    CommonManufacturerModal
  },
  data() {
    return {
      description: '制造商管理页面',
      isorter: {
        column: 'manuName',
        order: 'asc'
      },
      // 表头
      columns: [
        {
          title: '厂家',
          align: 'center',
          dataIndex: 'manuName',
          sorter: true
        },
        {
          title: '联系人',
          align: 'center',
          dataIndex: 'contactPerson',
          sorter: true
        },
        {
          title: '联系电话',
          align: 'center',
          dataIndex: 'contactPhone',
          sorter: true
        },
        {
          title: '电子邮件',
          align: 'center',
          dataIndex: 'contactEmail',
          sorter: true
        },
        {
          title: '经营范围',
          align: 'left',
          dataIndex: 'businessScope',
          width: 250,
          sorter: true
        },
        {
          title: '地址',
          align: 'left',
          dataIndex: 'addr',
          width: 200,
          sorter: true
        },
        {
          title: '备注',
          align: 'left',
          dataIndex: 'remark',
          width: 200,
          sorter: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/device/commonManufacturer/list',
        delete: '/device/commonManufacturer/delete',
        deleteBatch: '/device/commonManufacturer/deleteBatch',
        exportXlsUrl: '/device/commonManufacturer/exportXls',
        importExcelUrl: 'device/commonManufacturer/importExcel'
      },
      queryParam: {},
      dictOptions: {},
      superFieldList: [],
      detailRouteName: 'FusionManufacturers'
    }
  },
  created() {
    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    ...mapActions(['detailMapAction']),
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'manuName', text: '分类名称' })
      fieldList.push({ type: 'string', value: 'trade', text: '行业分类' })
      fieldList.push({ type: 'string', value: 'businessScope', text: '经营范围' })
      fieldList.push({ type: 'string', value: 'addr', text: '地址' })
      fieldList.push({ type: 'string', value: 'contact', text: '联系方式' })
      fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态' })
      this.superFieldList = fieldList
    }
  }
}
</script>
<style scoped>

@import '~@assets/less/common.less';

</style>
